import React from 'react';

import {svgIconWrapper} from '../icon/svg-icon-wrapper';

import GoogleLogo from './google-g.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoogleLogo {...validProps} />;
}
SvgComponent.iconName = 'google-logo';

export const GoogleLogoIcon = svgIconWrapper(SvgComponent);
